import { Controller } from "@hotwired/stimulus";

// Onglets de la section « Espaces » de la landing.
//
// Les styles actif/inactif sont dupliqués ici et dans la vue : la vue rend
// l'état initial côté serveur (l'onglet reste lisible sans JS), le contrôleur
// prend le relais au clic.
const ACTIVE_CLASSES = [
  "border-[#47A534]",
  "bg-[#47A534]",
  "font-bold",
  "text-white",
  "shadow-[0_6px_16px_rgba(71,165,52,.30)]",
];

const INACTIVE_CLASSES = [
  "border-white/20",
  "font-medium",
  "text-[#CBD5E1]",
  "hover:bg-white/[0.06]",
];

export default class extends Controller {
  static targets = ["tab", "panel"];

  select(event) {
    const index = this.tabTargets.indexOf(event.currentTarget);
    if (index === -1) return;

    this.tabTargets.forEach((tab, position) => {
      const active = position === index;
      tab.setAttribute("aria-selected", String(active));
      tab.classList.remove(...(active ? INACTIVE_CLASSES : ACTIVE_CLASSES));
      tab.classList.add(...(active ? ACTIVE_CLASSES : INACTIVE_CLASSES));
    });

    this.panelTargets.forEach((panel, position) => {
      panel.classList.toggle("hidden", position !== index);
    });
  }
}
